/**
 * Shared wishlist storage: a localStorage-backed list of product handles
 * (not numeric ids - the dedicated wishlist page needs to fetch each
 * product's live data client side via Shopify's `/products/<handle>.js`
 * endpoint, which only takes a handle), used by the product-card/gallery
 * heart buttons, the cart's "Save for later" action, and the wishlist page -
 * one storage module instead of each feature inventing its own. Emits
 * `vellum:wishlist-updated` (detail: { ids }) whenever the stored list
 * changes, so any UI reflecting it (header count, heart buttons, the
 * wishlist page) can re-sync without a reload.
 */
(function () {
  const STORAGE_KEY = 'vellum:wishlist';

  function readWishlist() {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(ids) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    window.dispatchEvent(new CustomEvent('vellum:wishlist-updated', { detail: { ids } }));
  }

  function addToWishlist(id) {
    const key = String(id);
    const ids = readWishlist();
    if (!ids.includes(key)) {
      ids.push(key);
      writeWishlist(ids);
    }
  }

  function removeFromWishlist(id) {
    const key = String(id);
    writeWishlist(readWishlist().filter((existing) => existing !== key));
  }

  function isWishlisted(id) {
    return readWishlist().includes(String(id));
  }

  function toggleWishlist(id) {
    if (isWishlisted(id)) {
      removeFromWishlist(id);
      return false;
    }
    addToWishlist(id);
    return true;
  }

  window.VellumWishlist = {
    readWishlist,
    addToWishlist,
    removeFromWishlist,
    isWishlisted,
    toggleWishlist,
  };
})();
